import { Action } from '@ngrx/store';
import { FilterDisplayType } from '@shared/shared/components/filter-bar/models/filter-interfaces';

export const GET_CURRENT_FILTERS = '[Filters] Get Current Filters';
export const GET_CURRENT_FILTERS_SUCCESS = '[Filters] Get Current Filters Success';
export const UPDATE_CURRENT_FILTERS = '[Filters] Update Current Filters';
export const UPDATE_CURRENT_FILTERS_SUCCESS = '[Filters] Update Current Filters Success';
export const CLEAR_CURRENT_FILTERS = '[Filters] Clear Current Filters';

export class GetCurrentFilters implements Action {
  readonly type = GET_CURRENT_FILTERS;
}

export class GetCurrentFiltersSuccess implements Action {
  readonly type = GET_CURRENT_FILTERS_SUCCESS;
  constructor(public payload: any) {}
}

export class UpdateCurrentFilters implements Action {
  readonly type = UPDATE_CURRENT_FILTERS;
  constructor(
    public payload?: {
      module: string;
      filterName: string;
      filterValue: any;
      disableScroll: boolean;
      filterType: FilterDisplayType;
    }
  ) {}
}

export class UpdateCurrentFiltersSuccess implements Action {
  readonly type = UPDATE_CURRENT_FILTERS_SUCCESS;
  constructor(public payload: any) {}
}

export class ClearCurrentFilters implements Action {
  readonly type = CLEAR_CURRENT_FILTERS;
}

export type CurrentFiltersAction =
  | GetCurrentFilters
  | GetCurrentFiltersSuccess
  | UpdateCurrentFilters
  | UpdateCurrentFiltersSuccess
  | ClearCurrentFilters;
